export const PATH_APP = {
  root: '/',
  room: '/room',
  users: '/users',
  booking: '/booking',
};
